module.exports = __webpack_public_path__ + "img/rku10-1.a62f03e9.png";